export default __webpack_public_path__ + "static/1-ce51fcd45fde99aa123a6b44676ed3de.png";